<template>
  <b-modal
    id="signup-real-person"
    hide-footer
    hide-header
    no-stacking
    @shown="firstShow"
  >
    <template v-slot:default="{ hide }">
      <!-- Close Button Container -->
      <div class="close-button-container">
        <span class="close-button" @click="hide()">&times;</span>
      </div>
      <!-- End Close Button Container -->

      <!-- Modal Main Content -->
      <div class="modal-main-content">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="roshd logo" />
        </div>
        <!-- Title -->
        <div class="heading mb-4">
          <h6>ثبت نام حامیان</h6>
        </div>
        <!-- End Title -->
        <!-- Form -->
        <form @submit.prevent="checkForm">
          <div
            class="form-group position-relative"
            :class="{ 'form-group--error': $v.fname.$error }"
          >
            <input
              type="text"
              name="first_name"
              class="form-control"
              v-model.trim="fname"
              @input="delayTouch($v.fname)"
              placeholder="نام"
            />
            <div class="error" v-if="!$v.fname.required">
              فیلد نام الزامی است.
            </div>
          </div>

          <div
            class="form-group position-relative"
            :class="{ 'form-group--error': $v.lname.$error }"
          >
            <input
              type="text"
              name="last_name"
              class="form-control"
              v-model.trim="lname"
              @input="delayTouch($v.lname)"
              placeholder="نام خانوادگی"
            />
            <div class="error" v-if="!$v.lname.required">
              فیلد نام خانوادگی الزامی است.
            </div>
          </div>

          <div
            class="form-group position-relative input-mobile"
            :class="{ 'form-group--error': $v.phoneNumber.$error }"
          >
            <input
              type="number"
              name="mobile"
              class="form-control mobile-with-combo"
              v-model.trim="phoneNumber"
              @input="delayTouch($v.phoneNumber)"
              placeholder="شماره موبایل"
            />

            <div class="combo-box">
              <select v-model="preMobile">
                <option
                  v-for="(val, key) in allCountry"
                  :key="key"
                  :value="val.phonecode"
                >
                  {{ val.phonecode }}
                </option>
              </select>
            </div>

            <div class="error" v-if="!$v.phoneNumber.required">
              فیلد شماره موبایل اجباری است.
            </div>
          </div>

          <div
            class="form-group position-relative input-national-code"
            :class="{ 'form-group--error': $v.nationalCode.$error }"
          >
            <input
              type="text"
              name="national_code"
              v-model.trim="nationalCode"
              @input="delayTouch($v.nationalCode)"
              class="form-control national-code-with-combo"
              placeholder="کد ملی"
            />

            <div class="combo-box">
              <select v-model="countryCode">
                <option
                  v-for="(val, key) in allCountry"
                  :key="key"
                  :value="val.id"
                >
                  {{ val.title_fa }}
                </option>
              </select>
            </div>

            <div class="error" v-if="!$v.nationalCode.required">
              فیلد کد ملی الزامی است.
            </div>
          </div>

          <!-- Password -->
          <span class="font-size-10"
            >حداقل 8 کاراکتر لاتین شامل اعداد و حروف کوچک و بزرگ</span
          >
          <div
            class="form-group input-password-type position-relative"
            :class="{ 'form-group--error': $v.pass.$error }"
          >
            <i
              class="icon-eye"
              @mousedown="password = 'text'"
              @mouseup="password = 'password'"
              @mouseleave="password = 'password'"
            ></i>

            <input
              :type="password"
              name="password"
              class="form-control"
              v-model.trim="pass"
              @input="delayTouch($v.pass)"
              placeholder="رمز عبور (فقط حروف و کاراکتر لاتین)"
            />

            <div class="error" v-if="!$v.pass.required">
              فیلد رمز عبور الزامی است.
            </div>
            <div class="error" v-if="!$v.pass.minLength">
              رمز عبور باید حداقل هشت کاراکتر باشد
            </div>
          </div>

          <div
            class="form-group input-password-type position-relative"
            :class="{ 'form-group--error': $v.confirm.$error }"
          >
            <i
              class="icon-eye"
              @mousedown="passwordConf = 'text'"
              @mouseup="passwordConf = 'password'"
              @mouseleave="passwordConf = 'password'"
            ></i>

            <input
              :type="passwordConf"
              name="password_confirmation"
              class="form-control"
              v-model.trim="confirm"
              @input="delayTouch($v.confirm)"
              placeholder="تکرار رمز عبور"
            />

            <div class="error" v-if="!$v.confirm.sameAsPassword">
              با رمز عبور مطابقت ندارد.
            </div>
          </div>
          <!-- Password -->

          <!-- Captcha -->
          <div class="captcha position-relative">
            <p class="font-size-12 mb-2">کد زیر را وارد کنید</p>
            <div class="captcha-box">
              <img :src="`${urlCap + captchaImg}`" alt="captcha" />
              <div class="form-group mb-0">
                <input
                  type="text"
                  name="captcha"
                  ref="captcha"
                  autocomplete="off"
                  required
                  v-model.trim="captchaInp"
                  :maxlength="captchaMax"
                />
              </div>
            </div>
          </div>
          <!-- Captcha -->

          <div class="text-center mt-4 mb-2">
            <b-overlay
              :show="busy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <button type="submit" :disabled="busy">ثبت نام</button>
            </b-overlay>
            <!-- v-b-modal.activation-code-real-person -->
          </div>
        </form>
        <!-- End Form -->
      </div>
      <!-- End Modal Main Content -->
    </template>
  </b-modal>
</template>

<script>
import axios from "@/axios";
import { formErrors, url } from "@/mixins.js";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
const touchMap = new WeakMap();

export default {
  name: "SignupRealPerson",
  mixins: [formErrors, url],
  data() {
    return {
      errorMessageCode: "",
      busy: false,
      passwordConf: "password",
      password: "password",
      fname: "",
      lname: "",
      preMobile: "98",
      phoneNumber: "",
      nationalCode: "",
      countryCode: "101",
      pass: "",
      confirm: "",
      captchaInp: "",
      captchaImg: "",
      captchaMax: 4,
    };
  },

  computed: {
    urlCap() {
      return `${this.basicUrl}assets/images/captcha/`;
    },

    allCountry() {
      return this.$store.state.countryList;
    },

    // defaultCountry() {
    //   return this.$store.state.lang.country;
    // },

    defaultPreMobile() {
      let arr = this.allCountry;
      let preMobile = arr.find((ele) => ele.iso == this.defaultCountry);
      return preMobile.phonecode;
    },

    getCountryId() {
      let arr = this.allCountry;
      let areaCode = arr.find((ele) => ele.iso == this.defaultCountry);
      return areaCode.id;
    },
  },

  methods: {
    async generateCaptcha(captchaCode) {
      let captcha;

      if (!captchaCode) {
        let data = new FormData();
        data.append("action", "create_captcha");

        await axios
          .post("captcha/create.php", data)
          .then((data) => {
            captcha = data.data;
          })
          .catch((err) => console.error("Error create captcha::", err));
      }

      this.captchaImg = captcha || captchaCode;
      this.captchaImg += ".png";
      this.captchaInp = "";
    },

    async checkForm() {
      // this.$root.$emit("bv::show::modal","activation-code-real-person");

      this.busy = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        setTimeout(() => {
          this.busy = false;
        }, 400);
        return;
      }

      if (this.phoneNumber[0] == 0) {
        this.phoneNumber = this.phoneNumber.substring(1);
      }

      let data = new FormData();
      data.append("action", "register");
      data.append("captcha", this.captchaInp);
      data.append("fname", this.fname);
      data.append("lname", this.lname);
      data.append("pre_mobile", this.preMobile);
      data.append("mobile", "" + this.phoneNumber);
      data.append("code_value", this.nationalCode);
      data.append("code_country_id", this.countryCode);
      data.append("password", this.pass);
      data.append("confirm", this.confirm);

      await axios
        .post("user/auth/register.php", data)
        .then((data) => {
          console.log("register:", data.data);

          switch (data.data.msg) {
            case "ip_blacklist":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case 11:
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "empty_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "password_min_length_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "success":
              this.$snotify.info("کد ارسالی به شماره خود را وارد کنید.");
              this.$emit("getPhoneNumber", "" + this.phoneNumber);
              this.$root.$emit(
                "bv::show::modal",
                "activation-code-real-person"
              );
              break;

            case "password_validate_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "password_confirm_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "pre_mobile_max_length_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "mobile_validate_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "mobile_unique_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "code_unique_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "code_validate_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "failure":
              this.$snotify.error(this.errors[data.data.msg]);
              break;

            case "validate_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "register_err":
              this.$snotify.error(this.errors[data.data.msg]);
              break;

            default:
              this.$snotify.error("خطا در برقراری ارتباط با سرور");
          }

          if (data.data.captcha) {
            this.generateCaptcha(data.data.captcha);
          }
        })
        .catch((err) => console.error("response Error register::", err));
      this.busy = false;
    },

    firstShow() {
      this.generateCaptcha();
      this.preMobile = this.defaultPreMobile;
      this.countryCode = this.getCountryId;
    },

    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1500));
    },
  },

  validations: {
    fname: {
      required,
    },
    lname: {
      required,
    },
    phoneNumber: {
      required,
    },
    nationalCode: {
      required,
    },
    pass: {
      required,
      minLength: minLength(8),
    },
    confirm: {
      sameAsPassword: sameAs("pass"),
    },
    captchaInp: {
      minLength: minLength(4),
    },
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>